import { DriverWithMoves } from './types';

/** One row from /driver-status-monitor/dispatch-requests. */
export interface DispatchRequest {
  recno: number;
  unitnumber: string;
  createdatetime: string;
  driver_dispatcher?: string;
}

/** The three pieces of DSM state keyed off a driver's open work request. */
export interface RequestingState {
  units: Set<string>;
  createdAt: Map<string, string>;
  lanes: DriverWithMoves[];
}

/**
 * Drop a driver from every requesting-work collection, returning new objects.
 *
 * Used to hide an acked lane immediately instead of waiting for the next poll.
 * The input is left untouched so the caller can hand it straight back if the
 * POST fails — silently hiding a driver who is still waiting for work is worse
 * than a lane that lingers for a few seconds.
 */
export function clearRequestingUnit(prev: RequestingState, unitnumber: string): RequestingState {
  const units = new Set(prev.units);
  units.delete(unitnumber);

  const createdAt = new Map(prev.createdAt);
  createdAt.delete(unitnumber);

  return {
    units,
    createdAt,
    lanes: prev.lanes.filter(lane => lane.unitnumber !== unitnumber),
  };
}

/**
 * Live toast ids for a driver's open requests, so acking can close the
 * persistent "requested more work" toasts it just made obsolete. A driver who
 * tapped the button repeatedly has one toast per request row.
 */
export function toastIdsForUnit(
  requests: DispatchRequest[],
  toastIds: Map<number, number>,
  unitnumber: string,
): number[] {
  return requests
    .filter(r => r.unitnumber === unitnumber)
    .map(r => toastIds.get(r.recno))
    .filter((id): id is number => id !== undefined);
}
